var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#343434",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.917 21.11a.848.848 0 00.57-.86v1.1a.91.91 0 01-.595.86l-7.588 2.733a.806.806 0 01-.596 0L8.12 22.211a.9.9 0 01-.595-.86v-1.1c0 .379.235.733.595.86l7.613 2.732a.806.806 0 00.595 0zm0-1.948a.867.867 0 00.57-.86v1.1a.91.91 0 01-.595.86l-7.588 2.733a.806.806 0 01-.596 0L8.12 20.263a.9.9 0 01-.595-.86V18.29c0 .392.235.733.595.872l7.613 2.733a.806.806 0 00.595 0zm0-1.96a.88.88 0 00.583-.848v1.1a.91.91 0 01-.596.86l-7.588 2.733a.806.806 0 01-.595 0L8.12 18.302a.9.9 0 01-.595-.86v-1.1c0 .379.235.733.595.86l7.613 2.732a.806.806 0 00.595 0zM7.5 10.662a.9.9 0 01.595-.86l7.601-2.745a.806.806 0 01.595 0l7.601 2.745a.9.9 0 01.595.86v4.832a.91.91 0 01-.595.86l-7.613 2.732a.806.806 0 01-.595 0l-7.589-2.732a.9.9 0 01-.595-.86z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAry);
export default __webpack_public_path__ + "static/media/ary.10e3f62511ece85aad6e3005d9c2f581.svg";
export { ForwardRef as ReactComponent };